import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhoneCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 32,
			cy: 32,
			r: 29.5,
			stroke: "#005AA0",
			strokeWidth: 5
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M45.5912 48.0715L48.5795 45.0517C49.4048 44.218 49.8773 43.0483 49.8773 41.8408C49.8773 40.6375 49.4069 39.4678 48.5816 38.632L43.4513 33.4408C42.5987 32.5798 41.4605 32.1073 40.2509 32.1073C39.0413 32.1073 37.9031 32.5819 37.0463 33.445L34.7825 35.7382C34.2008 35.5534 32.9786 34.9549 31.0613 33.0124C29.0537 30.9817 28.4888 29.728 28.3145 29.2282L30.6308 26.8846C32.2772 25.2193 32.273 22.1281 30.6308 20.4712L25.5068 15.2884C24.6521 14.4211 23.5139 13.9423 22.3001 13.9423C21.0842 13.9423 19.9439 14.4211 19.0976 15.2842L16.1072 18.3103C14.8451 19.5871 14.15 21.6073 14.15 24.0076C14.15 26.4877 15.0068 33.1216 22.9448 41.1541C28.388 46.6603 33.1319 48.7561 36.1496 49.5436C40.1249 50.5831 43.6529 50.035 45.5912 48.0715ZM46.0973 41.8405C46.0973 42.0605 46.0117 42.2723 45.8927 42.3926L42.9044 45.4124C42.0475 46.2804 39.8952 46.6156 37.1059 45.8863C33.7058 44.999 29.8133 42.7251 25.633 38.4964C19.9562 32.752 17.93 27.7597 17.93 24.0073C17.93 22.5366 18.2955 21.4732 18.7955 20.9673L21.7863 17.9409C21.932 17.7923 22.0996 17.722 22.3001 17.722C22.4992 17.722 22.6683 17.7931 22.8145 17.9413L27.9427 23.1285C28.1304 23.3178 28.1307 24.0366 27.9427 24.2267L25.626 26.5707L23.9692 28.2471L24.7453 30.4726C25.2623 31.9549 26.3765 33.65 28.3732 35.6696C30.3607 37.6833 32.0971 38.8509 33.638 39.3405L35.8454 40.0417L39.7364 36.1003C39.8765 35.9591 40.0493 35.887 40.2509 35.887C40.4541 35.887 40.6245 35.9579 40.7654 36.1002L45.893 41.2887C46.0115 41.4087 46.0973 41.6215 46.0973 41.8405Z",
			fill: "#005AA0"
		})
	]
});
const ForwardRef = forwardRef(SvgPhoneCircle);
export { ForwardRef as ReactComponent };
